// extracted by mini-css-extract-plugin
export default {"text":"RepositoryEmptyView_text__vpbmU"};